export default (firstname, lastname) => {
    return `${firstname} ${lastname}`
}